import { Exercise, ExerciseRequest } from "../../models/Exercise";
import { slavtHTTP } from "../http";

export function getExerciseDetails(exerciseId: string) {
  return slavtHTTP
    .get<Exercise>(`/exams/${exerciseId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createExercise(lessonId: string, exercise: ExerciseRequest) {
  return slavtHTTP
    .post<{ id: number }>(`/lessons/${lessonId}/exams`, exercise)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editExercise(exercise: ExerciseRequest) {
  return slavtHTTP
    .patch<{ id: number }>(`/exams/${exercise.id}`, exercise)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteExercise(exerciseId: number) {
  return slavtHTTP
    .delete<void>(`/exams/${exerciseId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
